/**
 *
 * @module entry
 * @desc {SDK.Content} entry point.
 *
 */

import ContentApi from './contentApi';
import ContentManager from './contentManager';
import GraphQlQuery from './graphQlQuery';
import GraphQlPersistedQuery from './graphQlPersistedQuery';
import ContentQuery from './contentQuery';
import SearchOverrides from './searchOverrides';

import Search from './search/entry';
import Watchlist from './watchlist/entry';
import Bookmarks from './bookmarks/entry';

/**
 *
 * @typedef SDK.Content
 * @type {Object}
 *
 * @property {ContentApi} ContentApi
 * @property {ContentManager} ContentManager
 * @property {GraphQlQuery} GraphQlQuery
 * @property {GraphQlPersistedQuery} GraphQlPersistedQuery
 * @property {ContentQuery} ContentQuery
 * @property {SearchOverrides} SearchOverrides
 *
 * @property {Bookmarks} Bookmarks
 * @property {Search} Search
 * @property {Watchlist} Watchlist
 *
 */

/**
 *
 * @type {SDK.Content}
 *
 */
export default {

    ContentApi,
    ContentManager,
    GraphQlQuery,
    GraphQlPersistedQuery,
    ContentQuery,
    SearchOverrides,

    Bookmarks,
    Search,
    Watchlist

};



// WEBPACK FOOTER //
// ./src/content/entry.js